/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */

import './Buttons/stopDisabledLinksFiring';
import './Tables/TableWrapper';
import Video from './Video/Video';
import Dropdown from './Dropdown/Dropdown';
import Tooltip from './Tooltip/Tooltip';
import AccordionStepper from './AccordionStepper/AccordionStepper';
import Accordion from './Accordion/Accordion';
import ComponentInit from '../js/utils/ComponentInit';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { Accordion, AccordionStepper, Video, Dropdown, Tooltip };

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default ComponentInit(componentList);
